module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_clip-a5613612113ab644e947763dae0e52b4.svg";